import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/seo/Seo";
import { publicApi } from "@/lib/api";
import { slugify } from "@/lib/slugify";

export default function Recursos() {
  const [items, setItems] = useState([]);
  useEffect(() => { publicApi.resources().then(setItems).catch(() => setItems([])); }, []);

  return (
    <main className="pt-[72px]">
      <Seo title="Recursos sobre normas ISO y sistemas de gestión" description="Artículos y guías prácticas sobre ISO 9001, ISO 14001, ISO 27001, auditorías y sistemas de gestión en Costa Rica." path="/recursos" />
      <header className="border-b border-[#1A1A1A]/10 py-16 md:py-24">
        <div className="mx-auto max-w-[1200px] px-5 md:px-10">
          <div className="eyebrow mb-6">Conocimiento práctico</div>
          <h1 className="display-1">Recursos sobre normas ISO</h1>
          <p className="mt-6 max-w-3xl font-serif text-2xl text-[#1B3B2B]">Guías y artículos para tomar mejores decisiones sobre implementación, auditoría y mejora de sistemas de gestión.</p>
        </div>
      </header>
      <section className="mx-auto max-w-[1200px] px-5 md:px-10 py-16 md:py-24" aria-label="Artículos y guías">
        {items.length === 0 ? <p>Estamos preparando nuevos recursos. Mientras tanto, puede explorar nuestras <Link to="/#normas" className="underline">normas y servicios</Link>.</p> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((item) => {
              const slug = item.slug || slugify(item.titulo);
              return <article key={item.id || slug} className="border border-[#1A1A1A]/10 p-6 flex flex-col">
                <div className="eyebrow text-[#1B3B2B]">{item.tipo || "Artículo"}</div>
                <h2 className="mt-4 font-serif text-3xl">{item.titulo}</h2>
                <p className="mt-4 text-[#4A4A4A] leading-relaxed flex-1">{item.resumen}</p>
                <Link to={`/recursos/${slug}`} className="mt-6 inline-flex items-center gap-2 link-underline">Leer recurso <ArrowUpRight className="w-4 h-4" /></Link>
              </article>;
            })}
          </div>
        )}
      </section>
    </main>
  );
}
